// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import DisplayValueText from 'customer-data-filters-ui/components/display/DisplayValueText';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const formatCurrencyCode = currencyCode => {
  return I18n.currencySymbols[currencyCode] ? `${I18n.currencySymbols[currencyCode].name_plural} ${I18n.currencySymbols[currencyCode].symbol_native}` : currencyCode;
};
export default class DisplayValueCurrencyCode extends Component {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleValueChange = value => {
      if (isResolved(value)) {
        this.setState({
          value: formatCurrencyCode(value.get('id'))
        });
      }
    };
    this.state = {
      value: ''
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.configureResolver(this.props);
  }
  componentDidUpdate(nextProps) {
    if (
    // eslint-disable-next-line react/prop-types
    nextProps.resolver !== /* eslint-disable-next-line react/prop-types */
    this.props.resolver || nextProps.value !== this.props.value) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleValueChange);
      }
      this.configureResolver(nextProps);
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleValueChange);
    }
  }
  configureResolver(props) {
    const {
      getFamilyValueResolver,
      operator,
      value
    } = props;
    const resolver = getFamilyValueResolver(operator);
    if (value) {
      if (resolver && typeof resolver.byId !== 'function') {
        Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'byId' function; operator.field: ${JSON.stringify(operator.field)}`));
      }
      this.referenceAtom = resolver.byId(value);
      watch(this.referenceAtom, this.handleValueChange);
      this.handleValueChange(deref(this.referenceAtom));
    }
  }
  focus() {
    this.refs.input.focus();
  }
  render() {
    const {
      value
    } = this.state;
    return /*#__PURE__*/_jsx(DisplayValueText, {
      value: value
    });
  }
}
DisplayValueCurrencyCode.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  getFamilyValueResolver: PropTypes.func.isRequired,
  value: PropTypes.string
};